export const ROLES = {
  view_cams: 'SETUP_FLEET_SPECIFICATIONS_VIEW',
  edit_cams: 'SETUP_FLEET_SPECIFICATIONS_EDIT',
  view_customer: 'CUSTOMER_SETUP_VIEW',
  edit_customer: 'CUSTOMER_SETUP_EDIT',
  view_product: 'PRODUCT_SETUP_VIEW',
  edit_product: 'PRODUCT_SETUP_EDIT',
  view_user: 'USER_SETUP_VIEW',
  edit_user: 'USER_SETUP_EDIT',
  view_user_group: 'PROFILE_SETUP',
  btn_admin: 'BTN_ADMIN',
  view_work_orders: 'WORK_ORDER_VIEW',
  create_work_orders: 'WORK_ORDER_CREATE',
  edit_work_orders: 'WORK_ORDER_EDIT',
  search: 'SEARCH',
  edit_dealer_setup: 'DEALER_SETUP_EDIT',
  site_view: 'SITE_SETUP_INFO_VIEW',
  site_edit: 'SITE_SETUP_INFO_EDIT',
  plant_view: 'PLANT_SETUP_INFO_VIEW',
  plant_edit: 'PLANT_SETUP_INFO_EDIT',
  edit_casing_grade: 'SETUP_CASING_GRADE_EDIT',
  view_casing_grade: 'SETUP_CASING_GRADE_VIEW',
  view_pos_interface: 'VIEW_POS_INTERFACES',
  edit_pos_interface: 'EDIT_POS_INTERFACES',
  delete_casings: 'DELETE_CASINGS',
  view_services: 'SETUP_SERVICES_VIEW',
  edit_services: 'SETUP_SERVICES_EDIT',
  inventory_role: 'INVENTORY_ACCESS',
  view_zone: 'ZONE_SETUP_VIEW',
  manage_emails: 'MANAGE_EMAILS',
  dataset_download: 'PRINT_REPORTS',
  view_log: 'VIEW_LOG'
};
